"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Video = function Video(_ref) {
  var size = _ref.size,
    heading = _ref.heading,
    subheading = _ref.subheading,
    whiteFont = _ref.whiteFont,
    cta = _ref.cta,
    video = _ref.video,
    poster = _ref.poster,
    autoplay = _ref.autoplay,
    inView = _ref.inView;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative image--horizontal flex flex-column justify-end height-100% ".concat(size)
  }, autoplay ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, inView && video && /*#__PURE__*/_react["default"].createElement("video", {
    className: "video",
    loop: true,
    autoPlay: true,
    muted: true,
    playsInline: true,
    poster: poster && poster || undefined
  }, /*#__PURE__*/_react["default"].createElement("source", {
    src: video,
    type: "video/mp4"
  }))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, inView && video && /*#__PURE__*/_react["default"].createElement("video", {
    className: "video",
    loop: true,
    onMouseOver: function onMouseOver(event) {
      return event.target.play();
    },
    onFocus: function onFocus(event) {
      return event.target.play();
    },
    onMouseOut: function onMouseOut(event) {
      return event.target.pause();
    },
    onBlur: function onBlur(event) {
      return event.target.pause();
    },
    muted: true,
    playsInline: true,
    poster: poster && poster || undefined
  }, /*#__PURE__*/_react["default"].createElement("source", {
    src: video,
    type: "video/mp4"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, heading && /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--image__heading', 'd8-u-ls-sm', 'text-md', whiteFont && 'd8-u-color-white')
  }, heading), subheading && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-ls-sm', whiteFont && 'd8-u-color-white')
  }, subheading)));
};
Video.propTypes = {
  size: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  autoplay: _propTypes["default"].bool,
  cta: _propTypes["default"].object,
  video: _propTypes["default"].string
};
var _default = exports["default"] = Video;